import { createContext, use } from 'react';
import { useStore } from 'zustand';

import { createWorkbenchRunStatusStore } from './workbench-run-status-store.js';

import type { WorkbenchRunStatusStoreApi, WorkbenchRunStatusStoreState } from './workbench-run-status-store.js';

/**
 * Stands in where no provider is mounted — surfaces that render the panel
 * outside a workbench runtime (Storybook, read-only transcripts) then see a
 * permanently idle run rather than throwing.
 */
const IDLE_RUN_STATUS_STORE = createWorkbenchRunStatusStore();

export const WorkbenchRunStatusContext = createContext<WorkbenchRunStatusStoreApi>(IDLE_RUN_STATUS_STORE);

/**
 * Returns the enclosing pane's run-status store handle for imperative access.
 *
 * @returns The scoped run-status store.
 */
export function useWorkbenchRunStatusStoreApi(): WorkbenchRunStatusStoreApi {
	return use(WorkbenchRunStatusContext);
}

/**
 * Subscribes to the enclosing pane's run status.
 *
 * @param selector - Selects the slice of state to subscribe to.
 * @returns The selected slice, re-rendering the caller when it changes.
 */
export function useWorkbenchRunStatus<T>(selector: (state: WorkbenchRunStatusStoreState) => T): T {
	return useStore(useWorkbenchRunStatusStoreApi(), selector);
}
